import { Flex, Typography, Image } from "antd"
import CustomButton from "../CustomButton/Button"
import EditIcon from "../../assets/icons/edit-icon.svg";

const { Text } = Typography;

const DetailSubHeader = ({ title, hasEdit, handleEdit }) => {
    return (
        <div className="detail-sub-header">
            <Flex align="center" justify="space-between">
                <Text className="title">{title}</Text>
                {hasEdit && (
                    <CustomButton
                        type="text"
                        icon={<Image src={EditIcon} alt="Edit" preview={false} />}
                        onClick={handleEdit}
                    />
                )}
            </Flex>
        </div>
    )
}

export default DetailSubHeader